export const commonExcludedSKUs = [
  // COMMON SKUS
  'ST', // SALESTOOL
  'snapshotreportrefresh',
  'RM-TRIAL', // RepMan Trial
  'MS', // Listing Builder Base Version
];

export const excludedSKUsProd = [
  // PROD SKUs
  'RM:EDITION-F7JZ5TV8', // RepMan Express
  'SM:EDITION-FVGBNLVZ', // SocialMarketing Express
  'MP-ee4ea04e553a4b1780caf7aad7be07cd:EDITION-VFNL43ZF', // WordPress Hosting Standard
  'MP-c4974d390a044c28aec31e421aa662b2:EDITION-TC8HJZNS', // Customer Voice Express
  'MP-94072e44d5364872b672d7ab4fc7a7e8', // AdIntel Express
  'MP-58G85F84DZBND7CK228578MWLD38SS4S', // CalendarHero
];

export const excludedSKUsDemo = [
  // DEMO SKUs
  'MP-9cc9f21f0a234a46ad78087fc09f16bc:EDITION-RC58KN73', // WordPress Hosting Standard
  'RM:EDITION-38SMW45H', // RepMan Express
  'SM:EDITION-SWVF3WH8', // SocialMarketing Express
  'MP-fba21121b71148c9bb33e11fcd92d520:EDITION-4WWZC3RJ', // Customer Voice Express
  'MP-94072e44d5364872b672d7ab4fc7a7e8', // AdIntel Express
  'MP-M2R4V4KZH4QLSRM3ZZ6DQB7N8Z6PL5NL', // CalendarHero
];

export const BILLING_ITEM_NOT_FOUND = 5;

export enum ParameterPath {
  SKU = '{.sku}',
  Approved = '{.approved}',
}
